module.exports = __webpack_public_path__ + "static/media/Mouth_3.a593481a.jpg";